"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var searchResultListBaseTheme = function (_a) {
    var _b;
    var MAX_M = _a.MAX_M;
    return ({
        searchResultListPaginationWrapper: {
            borderTop: "1px solid #EEEEEE"
        },
        searchResultListPagination: {
            display: "flex",
            justifyContent: "center"
        },
        searchResultList: {},
        searchResultListCount: (_b = {
                padding: "0.5rem 0",
                borderBottom: "none"
            },
            _b[MAX_M] = {
                padding: "0.5rem 0"
            },
            _b),
        searchResultListContainer: {},
    });
};
exports.default = searchResultListBaseTheme;
//# sourceMappingURL=searchResultList.js.map